<template lang="pug">
.login-vtexp-form
  .cabecalho.row.ab.col-s
    h3 {{ titulo }}
    span.sub(v-if="sugestao") {{ sugestao.sas }} atividade(s) · última agenda {{ sugestao.ultima_agenda | date }} · telefone {{ sugestao.telefone || 'não informado' }}
  .row.js.col-s.campos
    .col.g3.g12-s
      label(:for="'matricula-' + chave") MATRÍCULA
      input.input(v-if="editavel" :id="'matricula-' + chave" v-model="form.matricula_vtexp" placeholder="MATRICULA VTEXP" @blur="sugerir" @keydown.enter.prevent="sugerir")
      input.input(v-else :id="'matricula-' + chave" :value="form.matricula_vtexp" readonly)
      small(v-if="editavel") Ao sair do campo, a tela busca a matrícula nas atividades da V.tal e no cadastro.
      small(v-else) Matrícula da pendência, como a V.tal informa.
    .col.g5.g12-s
      label(:for="'nome-' + chave") NOME (V.TAL)
      input.input(v-if="editavel" :id="'nome-' + chave" v-model="form.nome_vtexp" placeholder="NOME VTEXP")
      input.input(v-else :id="'nome-' + chave" :value="form.nome_vtexp" readonly)
      small(v-if="editavel") Preenchido pela sugestão quando a matrícula já apareceu em atividade.
  .carregando.row.ac(v-if="carregando")
    Loader(layout="mini")
    span Buscando a matrícula nas atividades e no cadastro…
  p.msg.aviso.nao-encontrada(v-else-if="naoEncontrada") Matrícula não encontrada nas atividades da V.tal nem no cadastro.
    template(v-if="editavel") &nbsp;O cadastro segue sem sugestão: escolha o supporter pela busca, ou cadastre só o login.
  .login-existente(v-if="login")
    b Login {{ login.id }} já cadastrado
    span &nbsp;· status {{ login.status }} · operacional {{ login.status_operacional }}
    span(v-if="login.doutor") &nbsp;· vinculado a {{ login.doutor.nome }} (ID {{ login.doutor.id }}, usuário {{ login.doutor.status_usuario }})
    span(v-else) &nbsp;· sem supporter vinculado
  p.msg.ok.vinculado(v-if="modo === 'vinculado'") Esta matrícula já está cadastrada e vinculada. Nada a fazer aqui.
  p.msg.aviso.bloqueado(v-else-if="modo === 'bloqueado'") Vínculo bloqueado pelo cadastro do supporter. A liberação excepcional é do Diretor de Operação.
  template(v-else)
    CandidatosSupporter(v-if="mostraCandidatos" :candidatos="candidatos" v-model="escolhido")
    p.msg.aviso.impedimento(v-if="escolhido && escolhido.permite_vinculo === false") {{ escolhido.impedimento }} {{ modo === 'cadastrar' ? 'O login será gravado e o vínculo, recusado.' : 'O vínculo será recusado.' }}
    .excecao(v-if="mostraExcecao")
      p.msg.aviso(v-if="excecaoAberta") Vínculo recusado pelo cadastro do supporter. Como Diretor de Operação ou TI, você pode liberar por um prazo.
      .row.ae.col-s
        .col.g2.g12-s
          label(:for="'dias-' + chave") DIAS
          input.input(:id="'dias-' + chave" v-model="excecao.dias" type="number" min="1" placeholder="Dias")
        .col.g8.g12-s
          label(:for="'motivo-' + chave") MOTIVO
          input.input(:id="'motivo-' + chave" v-model="excecao.motivo" placeholder="Motivo da liberação")
      small(v-if="supporterAlvo") Para o supporter {{ supporterAlvo.nome }} (ID {{ supporterAlvo.id_doutor }}).
  .acoes.row.ac.col-s
    Button.cancelar(layout="red-s" @click="$emit('cancelar')") CANCELAR
    Button.enviar(v-if="modo !== 'vinculado' && modo !== 'bloqueado'" layout="green-go" :disabled="!podeEnviar" :loader="enviando" @click="enviar" style="margin-left: 12px") {{ rotuloEnviar }}
    small.dica(v-if="dicaEnviar") {{ dicaEnviar }}
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import Button from "@/components/Button";
import Loader from "@/components/Loader";
import CandidatosSupporter from "@/views/admin/components/CandidatosSupporter";

const TITULOS = {
  cadastrar: "CADASTRAR LOGIN V.TEXP", vincular: "VINCULAR SUPPORTER AO LOGIN", excecao: "LIBERAÇÃO EXCEPCIONAL",
  vinculado: "LOGIN JÁ VINCULADO", bloqueado: "VÍNCULO BLOQUEADO",
}
const MODO_DA_ACAO = { cadastrar_vincular: "cadastrar", vincular: "vincular", excecao: "excecao" }
const limpar = (v) => String(v || "").trim()

// Formulário de login V.texp a partir da sugestão da V.tal (sc-9881). Pela pendência, a matrícula
// vem travada e a ação decide o modo; no cadastro comum (`editavel`), a sugestão é buscada ao sair
// do campo e o modo sai do que o backend já conhece da matrícula. Sugerir não é vincular: quem
// escolhe o supporter e confirma é a operação. Três saídas: cadastrar (com ou sem vínculo),
// vincular um login existente e a liberação excepcional (dias e motivo), só para quem pode.
export default {
  name: "LoginVtexpForm",
  components: { Button, Loader, CandidatosSupporter },
  props: {
    matricula: { type: String, default: "" },
    acao: { type: String, default: "" },
    editavel: { type: Boolean, default: false },
    podeExcecao: { type: Boolean, default: false },
  },
  data() {
    return {
      form: { matricula_vtexp: this.matricula, nome_vtexp: "" },
      sugestao: null, naoEncontrada: false, carregando: false, pedido: 0,
      escolhido: null, enviando: false, excecaoAberta: false, excecao: { dias: 1, motivo: "" },
    };
  },
  computed: {
    chave() { return limpar(this.matricula) || "novo" },
    login() { return this.sugestao ? this.sugestao.login : null },
    candidatos() { return this.sugestao ? this.sugestao.candidatos : [] },
    supporterDoLogin() {
      const d = this.login && this.login.doutor
      return d ? { id_doutor: d.id, nome: d.nome, email: d.email, cpf: d.cpf, status_usuario: d.status_usuario } : null
    },
    modo() {
      if (MODO_DA_ACAO[this.acao]) return this.modoPermitido(MODO_DA_ACAO[this.acao])
      if (!this.login) return "cadastrar"
      if (!this.login.id_doutor) return "vincular"
      return this.login.status === "bloqueado" ? this.modoPermitido("excecao") : "vinculado"
    },
    titulo() { return TITULOS[this.modo] },
    mostraCandidatos() {
      if (!this.sugestao && !this.naoEncontrada) return false
      if (this.modo === "excecao") return !this.supporterDoLogin
      return this.modo === "cadastrar" || this.modo === "vincular"
    },
    mostraExcecao() { return this.modo === "excecao" || this.excecaoAberta },
    supporterAlvo() { return this.escolhido || (this.modo === "excecao" ? this.supporterDoLogin : null) },
    excecaoValida() { return parseInt(this.excecao.dias) >= 1 && limpar(this.excecao.motivo).length > 0 },
    formPreenchido() { return !!(limpar(this.form.matricula_vtexp) && limpar(this.form.nome_vtexp)) },
    podeEnviar() {
      if (this.enviando || this.carregando) return false
      if (this.mostraExcecao) return !!this.login && !!this.supporterAlvo && this.excecaoValida
      if (this.modo === "vincular") return !!this.login && !!this.escolhido
      if (this.modo !== "cadastrar") return false
      return this.formPreenchido && (!!this.escolhido || this.editavel)
    },
    rotuloEnviar() {
      if (this.mostraExcecao) return "CONCEDER EXCEÇÃO"
      if (this.modo === "vincular") return "VINCULAR"
      return this.escolhido ? "CADASTRAR E VINCULAR" : "CADASTRAR SEM VÍNCULO"
    },
    dicaEnviar() {
      if (this.podeEnviar || this.carregando || this.enviando) return ""
      if (this.mostraExcecao) return "Para conceder: o supporter, os dias (1 ou mais) e o motivo."
      if (this.modo === "vincular") return "Escolha o supporter para vincular."
      if (this.modo === "cadastrar") return this.formPreenchido ? "Escolha o supporter para cadastrar e vincular." : "Informe a matrícula e o nome da V.tal."
      return ""
    },
  },
  mounted() {
    if (limpar(this.matricula)) this.sugerir()
  },
  methods: {
    ...mapActions("admin", ["VTEXP_SUGESTAO", "VTEXP_CADASTRA_VINCULA", "VTEXP_NOVO", "VTEXP_VINCULA", "VTEXP_VINCULA_EXCECAO"]),
    ...mapMutations("general", ["SET_STATUS"]),
    modoPermitido(modo) { return modo === "excecao" && !this.podeExcecao ? "bloqueado" : modo },
    async sugerir() {
      const m = limpar(this.form.matricula_vtexp)
      if (!m) return
      const pedido = ++this.pedido
      this.carregando = true
      const r = await this.VTEXP_SUGESTAO(m)
      if (pedido !== this.pedido) return
      this.carregando = false
      this.escolhido = null
      this.excecaoAberta = false
      if (r.status == 200) this.receber(r.data)
      else if (r.status == 404) { this.sugestao = null; this.naoEncontrada = true }
    },
    receber(sugestao) {
      this.sugestao = sugestao
      this.naoEncontrada = false
      this.form.matricula_vtexp = sugestao.matricula
      if (!this.editavel || !limpar(this.form.nome_vtexp)) this.form.nome_vtexp = sugestao.nome_vtexp
    },
    async enviar() {
      if (!this.podeEnviar) return
      this.enviando = true
      if (this.mostraExcecao) await this.conceder()
      else if (this.modo === "vincular") await this.vincular()
      else await this.cadastrar()
      this.enviando = false
    },
    async cadastrar() {
      const corpo = { matricula_vtexp: limpar(this.form.matricula_vtexp), nome_vtexp: limpar(this.form.nome_vtexp) }
      if (!this.escolhido) {
        const r = await this.VTEXP_NOVO(corpo)
        if (r.status == 200) this.$emit("salvo", { login: r.data, vinculado: false, motivo_recusa: null })
        return
      }
      const r = await this.VTEXP_CADASTRA_VINCULA({ ...corpo, id_doutor: this.escolhido.id_doutor })
      if (r.status != 200) return
      this.avisarCadastro(corpo.matricula_vtexp, r.data)
      this.$emit("salvo", r.data)
    },
    avisarCadastro(matricula, resultado) {
      if (resultado.vinculado)
        return this.SET_STATUS({ text: `Login ${matricula} cadastrado e vinculado a ${resultado.login.doutor.nome}.`, color: "green" })
      this.SET_STATUS({
        text: `Login ${matricula} cadastrado; vínculo recusado: ${resultado.motivo_recusa} A matrícula volta às pendências como "Sem vínculo": vincule outro supporter ou peça a liberação ao Diretor de Operação.`,
        color: "orange",
      })
    },
    async vincular() {
      const r = await this.VTEXP_VINCULA({ id: this.login.id, id_doutor: this.escolhido.id_doutor, etag: this.login.etag })
      if (r.status == 200) {
        if (!(r.data && r.data.msg)) this.SET_STATUS({ text: `Login ${this.login.matricula_vtexp} vinculado a ${this.escolhido.nome}.`, color: "green" })
        return this.$emit("salvo", { login: r.data, vinculado: true, motivo_recusa: null })
      }
      // 403 é a recusa pelo cadastro do supporter; o notify já mostrou o motivo. Quem pode, concede a exceção.
      if (r.status == 403 && this.podeExcecao) this.excecaoAberta = true
    },
    async conceder() {
      const corpo = { id: this.login.id, id_doutor: this.supporterAlvo.id_doutor, dias: parseInt(this.excecao.dias), motivo: limpar(this.excecao.motivo), etag: this.login.etag }
      const r = await this.VTEXP_VINCULA_EXCECAO(corpo)
      if (r.status != 200) return
      if (!(r.data && r.data.msg)) this.SET_STATUS({ text: `Exceção de ${corpo.dias} dia(s) concedida: login ${this.login.matricula_vtexp} vinculado a ${this.supporterAlvo.nome}.`, color: "green" })
      this.$emit("salvo", { login: r.data, vinculado: true, motivo_recusa: null })
    },
  },
};
</script>

<style lang="sass" scoped>
@use "sass:color"
@use "@/assets/scss/vars.scss" as *
.login-vtexp-form
  background: #f9f9f9
  border: 1.6px solid #ccc
  border-radius: 16px
  padding: 22px
  margin-top: 18px
  label
    @include label
    display: block
  small
    display: block
    color: $gray-5
    font-size: 12px
    line-height: 1.45
    margin-top: 4px
  .input
    width: 100%
    box-sizing: border-box
  .cabecalho
    margin-bottom: 18px
    h3
      margin: 0
      color: $purple
      font-size: 15px
      letter-spacing: .5px
    .sub
      color: $gray-5
      font-size: 13px
      margin-left: 14px
  .campos
    gap: 22px
  .carregando
    margin-top: 14px
    color: $gray-5
    font-size: 13px
    .loader
      margin-right: 10px
  .login-existente
    margin-top: 14px
    padding: 10px 14px
    background: white
    border: 1px solid $white-6
    border-radius: 8px
    font-size: 13px
    b
      color: $purple
  .candidatos-supporter
    margin-top: 18px
  .excecao
    margin-top: 18px
    .row
      gap: 18px
  .msg
    margin: 10px 0 0
    font-size: 13px
    line-height: 1.45
    padding: 8px 10px
    border-radius: 8px
    &.ok
      background: $green-3
      color: $green-6
    &.aviso
      background: rgba($orange-1, .15)
      color: color.adjust($orange-1, $lightness: -25%)
  .acoes
    margin-top: 22px
    .dica
      margin: 0 0 0 14px
</style>
